module.exports = __webpack_public_path__ + "static/media/mansura_thumb_even.f99a0334.jpg";